module.exports = "../images/icons-race-details/Calendar.svg";